module.exports = __webpack_public_path__ + "h5/img/6.0979bad2.png";